import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { siteData } from '../data/mock';

const Footer = () => {
  return (
    <footer style={{
      background: 'var(--text-primary)',
      color: 'white',
      padding: '3rem 0 1.5rem'
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '3rem',
          marginBottom: '2rem'
        }}>
          {/* About */}
          <div>
            <img loading="lazy" 
              src="/images/logo.webp" 
              alt="Nutri Centre Riviera" 
              style={{ height: '2.5rem', width: 'auto', marginBottom: '1rem', filter: 'brightness(0) invert(1)' }}
            />
            <h3 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.75rem' }}>
              {siteData.siteName}
            </h3>
            <p style={{ fontSize: '0.9rem', opacity: 0.9, lineHeight: 1.6 }}>
              {siteData.subtitle}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ fontSize: '0.9rem', fontWeight: 600, marginBottom: '1rem', textTransform: 'uppercase', letterSpacing: '0.12em', color: '#C5A880' }}>
              Navigation
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <li><Link to="/" style={{ color: 'white', opacity: 0.9, textDecoration: 'none', transition: 'opacity 0.2s' }}>Accueil</Link></li>
              <li><Link to="/le-centre" style={{ color: 'white', opacity: 0.9, textDecoration: 'none', transition: 'opacity 0.2s' }}>Le centre</Link></li>
              <li><Link to="/consultations" style={{ color: 'white', opacity: 0.9, textDecoration: 'none', transition: 'opacity 0.2s' }}>Consultations</Link></li>
              <li><Link to="/equipe" style={{ color: 'white', opacity: 0.9, textDecoration: 'none', transition: 'opacity 0.2s' }}>Équipe</Link></li>
              <li><Link to="/blog" style={{ color: 'white', opacity: 0.9, textDecoration: 'none', transition: 'opacity 0.2s' }}>Blog</Link></li>
              <li><Link to="/glossaire" style={{ color: 'white', opacity: 0.9, textDecoration: 'none', transition: 'opacity 0.2s' }}>Glossaire</Link></li>
              <li><Link to="/contact" style={{ color: 'white', opacity: 0.9, textDecoration: 'none', transition: 'opacity 0.2s' }}>Contact</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 style={{ fontSize: '0.9rem', fontWeight: 600, marginBottom: '1rem', textTransform: 'uppercase', letterSpacing: '0.12em', color: '#C5A880' }}>
              Contact
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                <MapPin size={18} style={{ marginTop: '0.2rem', flexShrink: 0 }} />
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                  <span style={{ fontSize: '0.9rem', opacity: 0.9 }}>{siteData.contact.address}</span>
                  <a
                    href="https://maps.app.goo.gl/daz8s3eydncNWeqPA"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-google-maps-link"
                    style={{
                      fontSize: '0.82rem',
                      color: 'white',
                      opacity: 0.85,
                      textDecoration: 'underline'
                    }}
                  >
                    Itinéraire (Google Maps)
                  </a>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <Phone size={18} style={{ flexShrink: 0 }} />
                <span style={{ fontSize: '0.9rem', opacity: 0.9 }}>{siteData.contact.phone}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <Mail size={18} style={{ flexShrink: 0 }} />
                <span style={{ fontSize: '0.9rem', opacity: 0.9 }}>{siteData.contact.email}</span>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h4 style={{ fontSize: '0.9rem', fontWeight: 600, marginBottom: '1rem', textTransform: 'uppercase', letterSpacing: '0.12em', color: '#C5A880' }}>
              Horaires
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                <Clock size={18} style={{ marginTop: '0.2rem', flexShrink: 0 }} />
                <div style={{ fontSize: '0.9rem', opacity: 0.9 }}>
                  <div>{siteData.contact.hours.weekdays}</div>
                  <div>{siteData.contact.hours.saturday}</div>
                  <div>{siteData.contact.hours.sunday}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          paddingTop: '1.5rem',
          marginTop: '2rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.75rem',
          textAlign: 'center'
        }}>
          <p style={{ fontSize: '0.85rem', opacity: 0.8, margin: 0 }}>
            {`© 2026 ${siteData.siteName} - ${siteData.author}. Tous droits réservés.`}
          </p>
          <Link
            to="/mentions-legales"
            data-testid="footer-legal-link"
            style={{
              fontSize: '0.85rem',
              color: 'white',
              opacity: 0.8,
              textDecoration: 'underline'
            }}
          >
            Mentions légales & Confidentialité
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
